var state = {},
    videoPopupRegExp = new RegExp('(^/(video)|(live)/)([a-zA-Z]{1}[0-9]+/)?[0-9]+', 'i');
state.previousLayerUrl = {};
state.stateBeforeLayerWasOpened = {};

/**
 * Функция для проверки начинается ли URL с префикса видео-витрины
 * @param {string} newUrl
 * @param {string=} layer который открывается этим newUrl
 * @return {boolean}
 */
function isVideoUrl(newUrl, layer) {
    if (!layer || layer === 'vitrine') {
        return !newUrl.indexOf('/video/') || newUrl === '/live';
    } else if (layer === 'popVideo') {
        return videoPopupRegExp.test(newUrl);
    } else {
        return false;
    }
}

function isNeedToUseGroupOrFriendVideoPageAsInitial(url, layer) {
    if (!layer || layer !== 'popVideo') {
        return false;
    }
    return url.indexOf('/video/') > 0;
}

/**
 * Метод для добавления в историю нового состояния
 * @param {string} newUrl новый URL
 * @param {boolean} isInitial флаг является ли URL инициальным для блока
 * @param {string} layer который открывается этим newUrl
 */
function pushNewUrl(newUrl, isInitial, layer) {
    if (!newUrl || !newUrl.trim()) {
        return;
    }
    // Gwt could be not initialized yet
    if (OK.historyManager.isHistorySupported()) {
        // HistoryManager is binded from gwt
        var currentState = OK.historyManager.getState();
        if (currentState !== newUrl) {
            OK.historyManager.pushState(newUrl);
        }
        if (isInitial && !state.stateBeforeLayerWasOpened[layer] && !isVideoUrl(currentState, layer)) {
            if (isNeedToUseGroupOrFriendVideoPageAsInitial(newUrl, layer) && currentState === newUrl) {
                state.stateBeforeLayerWasOpened[layer] = currentState.substring(0, currentState.lastIndexOf('/'));
            } else {
                state.stateBeforeLayerWasOpened[layer] = currentState;
            }
        }
        state.previousLayerUrl[layer] = newUrl;
        state.currentLayer = layer;
    }
}

/**
 * Метод для сброса состояния к изначальному, после закрытия леера
 * @param {string} layer который открывается этим newUrl
 */
function popInitialState(layer) {
    if (!OK.historyManager.isHistorySupported()) {
        return;
    }

    var currentState = OK.historyManager.getState();
    // проверим является ли это переходом по 'back' в другой раздел витрины (или в related video в PopVideo)
    if ((state.previousLayerUrl[layer] || state.previousLayerUrl[layer] === null)
            && currentState !== state.previousLayerUrl[layer] && isVideoUrl(currentState)) {
        return;
    }
    if (!state.stateBeforeLayerWasOpened[layer]) {
        OK.historyManager.pushState('/');
        state.previousLayerUrl[layer] = null;
    } else if (state.stateBeforeLayerWasOpened[layer] === currentState || state.previousLayerUrl[layer] === currentState) {
        OK.historyManager.pushState(state.stateBeforeLayerWasOpened[layer]);
        state.stateBeforeLayerWasOpened[layer] = null;
        state.previousLayerUrl[layer] = null;
    }
}

function popInitialStateVideoVitrine() {
    popInitialState('vitrine');
}

function popInitialStatePopupVideo() {
    popInitialState('popVideo');
}

/**
 * History handling function
 * @param {boolean} isInitial флаг является ли URL инициальным для блока
 * @param {string} layer который открывается этим newUrl
 */
function pushHistoryItemFromElementHandler(isInitial, layer) {
    if (this.tagName === 'A') {
        pushNewUrl(this.getAttribute('href'), isInitial, layer);
    } else {
        pushNewUrl($(this).data('history'), isInitial, layer);
    }
}

export default { popInitialStateVideoVitrine, popInitialStatePopupVideo, pushNewUrl, isVideoUrl, pushHistoryItemFromElementHandler };

export { popInitialStateVideoVitrine, popInitialStatePopupVideo, pushNewUrl, isVideoUrl, pushHistoryItemFromElementHandler };
